// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"885":"2153c6121497a778465a","5531":"2153c6121497a778465a"}[chunkId] + ".css";
};